module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "agent-apply-dialog",
    attrs: {
      "close-on-click-modal": false,
      "title": _vm.title,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "经销商类型"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeAgentType
    },
    model: {
      value: (_vm.form.Industry_Id),
      callback: function($$v) {
        _vm.$set(_vm.form, "Industry_Id", $$v)
      },
      expression: "form.Industry_Id"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 9
    }
  }, [_vm._v("个人")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 14
    }
  }, [_vm._v("公司")])], 1)], 1)], 1), _vm._v(" "), _c('base-info-form', {
    ref: "baseInfo",
    attrs: {
      "value": _vm.baseInfo,
      "isRequired": _vm.isRequired
    },
    on: {
      "showSelectStaffDialog": _vm.showSelectStaffDialog
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('selectStaffDialog', {
    ref: "refSelectStaffDialog",
    on: {
      "selectedStaff": _vm.selectedStaff
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f541a88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/CRMFormatAgent/components/addCompany/index.vue
// module id = 1436
// module chunks = 1